export default {
  title: {
    id: 'buyback_offer_title',
    defaultMessage: 'Trade-in',
  },
  priceOffer: {
    id: 'buyback_offer_price_offer',
    defaultMessage: 'Your price offer:',
  },
  congratsOffer: {
    id: 'buyback_offer_congrats_offer',
    defaultMessage: 'Congrats on your offer!',
  },
  summary: {
    id: 'buyback_offer_summary',
    defaultMessage: 'Device summary',
  },
  reassuranceOffer: {
    id: 'buyback_offer_reassurance_offer',
    defaultMessage:
      'We found the highest offer among our network of 250 partners.',
  },
  acceptOffer: {
    id: 'buyback_offer_accept_offer',
    defaultMessage: 'Accept',
  },
  declineOffer: {
    id: 'buyback_offer_decline_offer',
    defaultMessage: 'Decline',
  },
}
